// root '../../../';

// dependencies
import { Child } from 'pym.js';
import { select } from 'd3-selection';
import * as d3 from 'd3'; // for fetching JSON
import Zion from './utils/Zion';

// polyfills
import './utils/polyfills';

// utils & graphic
import config from './config';
import graphic from './graphic';

// styles
// import './styles/index.scss';
import './styles/graphic.scss';

import meta from './data/meta.json';

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

window.onload = () => {
  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);
      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

function draw(initialWidth) {
  const container = select('#graphic');
  container.html('');

  const fallbackWidth = container.node().clientWidth || 600;
  const safeWidth = initialWidth !== fallbackWidth ? fallbackWidth : initialWidth;
  const isMobile = safeWidth <= 500;

  d3.json('https://ix.cnn.io/data/measles/toplines_measles_cases.json').then((jsonData) => {
    // jsonData is an array with one object
    const measlesData = jsonData[0];
    const row = { label: 'Status' };
    measlesData.vax_df_final_list.forEach((item) => {
      row[item.metric] = item.value;
    });

    // Update meta elements using live JSON values:
    d3.select('h2.dek').html(`${measlesData.vax_status_summary}`);
    d3.select('p.footnote').html(`Note: Data current through ${measlesData.updated_date} and last checked on ${measlesData.last_updated_str}. Figures may not equal 100% due to rounding by the CDC..`);

    const stackedData = [row];
    const heightMultiplier = isMobile ? 1 : 9 / 16;
    const initialHeight = heightMultiplier * safeWidth;

    const props = config({
      initialWidth: safeWidth,
      initialHeight,
      isMobile,
      data: stackedData,
    });

    graphic(props, container, isMobile);
    window.pymChild.sendHeight();
  });
}
